import { isAbsoluteUrl } from "@/lib/utils";
import { PlaceholderValue } from "next/dist/shared/lib/get-img-props";
import NextImage from "next/image";
import { forwardRef, useEffect, useState } from "react";
import { ImagePropsModel } from "./Image.model";

const Image = forwardRef<HTMLImageElement, ImagePropsModel>(function Image(
  { src, className, hasPlaceholder, ...props }: ImagePropsModel,
  ref,
) {
  const [dataURL, setDataUrl] = useState<PlaceholderValue>();
  const [loading, setLoading] = useState(true);

  const toDataURL = (url: string) =>
    fetch(url)
      .then(response => response.blob())
      .then(
        blob =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          }),
      );

  useEffect(() => {
    if (typeof src === "string" && hasPlaceholder) {
      if (isAbsoluteUrl(src)) {
        try {
          const { origin, pathname } = new URL(src);
          toDataURL(`${origin}${pathname}?fm=webp&w=30`).then(dataURL =>
            setDataUrl(dataURL as PlaceholderValue),
          );
        } catch (err) {
          console.error(err);
        }
      }
    }
  }, [src, hasPlaceholder]);

  return (
    <NextImage
      {...props}
      ref={ref}
      src={src}
      placeholder={loading && dataURL ? "blur" : undefined}
      blurDataURL={dataURL}
      className={className}
      onLoad={() => setLoading(false)}
    />
  );
});

export default Image;
